export const selectBrukerTyper = (state) => {
    let brukertyper = null
    if (state.kodeverk && state.kodeverk.brukertyper) {
        ;({ brukertyper } = state.kodeverk)
    }
    return brukertyper
}
